module.exports = __webpack_public_path__ + "img/goods5_5.6f0f4a51.jpg";